export interface Cookie {
  name: string;
  value: string;
  path?: string;
  secure?: boolean;
  sameSite?: 'lax' | 'strict' | 'none';
  domain?: string;
  maxAge: number;
  encode?: boolean;
  decode?: boolean;
}

export function setCookie(options: Cookie) {
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + options.maxAge);

  let cookie = `${options.encode ? encodeURIComponent(options.name) : options.name}=${
    options.encode ? encodeURIComponent(options.value) : options.value
  }`;

  cookie += `;expires=${expirationDate.toUTCString()}`;
  cookie += `;path=${options.path || '/'}`;

  if (options.domain) {
    cookie += `;domain=${options.domain}`;
  }

  if (options.secure) {
    cookie += ';secure';
  }

  if (options.sameSite) {
    cookie += `;sameSite=${options.sameSite}`;
  }

  document.cookie = cookie;
}

export function deleteCookie(name: string, path = '/') {
  const cookie = `${encodeURIComponent(name)}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=${path}`;

  document.cookie = cookie;
}

export function getCookie(name: string, decode = false) {
  const cookies = document.cookie.split(';');

  for (let cookie of cookies) {
    cookie = cookie.trim();

    if (cookie.startsWith(encodeURIComponent(name) + '=')) {
      return decode ? decodeURIComponent(cookie.substring(name.length + 1)) : cookie.substring(name.length + 1);
    }
  }

  return null;
}
